import { NgModule } from '@angular/core';
import {
  CrmTranslateConfig,
  CrmTranslateModule,
} from 'common-module/translate';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { TranslocoConfig } from '@ngneat/transloco';

registerLocaleData(en);

const translateConfig: CrmTranslateConfig = {
  loader: {
    remoteLocale: false,
    remoteEnvs: [],
    localeFolder: './assets/locales/',
    remoteLocaleUrl: undefined,
    remoteLocalePath: 'content',
    remoteLocaleUrlParams: {
      key: 'i18n',
    },
  },
  locale: {
    defaultLocale: 'en',
    locales: {
      en: {
        ngLocale: en,
        nzLocale: en_US,
      },
    },
  },
  formatter: {
    date: {
      defaultFormat: 'P',
    },
  },
};

const translocoConfig: TranslocoConfig = {
  defaultLang: 'en',
  availableLangs: ['en'],
};

@NgModule({
  imports: [CrmTranslateModule.forRoot(translateConfig, translocoConfig)],
  exports: [],
  declarations: [],
  providers: [],
})
export class TranslateModule {}
